export default __webpack_public_path__ + "static/media/key-door.2e319763.jpg";